module.exports = __webpack_public_path__ + "images/picksforyou.da97f103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/picksforyou.jpg
// module id = 7eab5915
// module chunks = 10 37